import {
  PutHomologarPropietario,
  GetVerificarPropietarioDuplicado
} from "../../../reducers/personaReferencia";

export interface HomologarPropietarioStore
  extends PutHomologarPropietario,
    GetVerificarPropietarioDuplicado {}

export const homologarPropietarioStore: (
  state
) => HomologarPropietarioStore = state => {
  const { personaReferencia } = state;
  return {
    puttingHomologarPropietario: personaReferencia.puttingHomologarPropietario,
    puttingHomologarPropietarioError:
      personaReferencia.puttingHomologarPropietarioError,
    propietarioDuplicado: personaReferencia.propietarioDuplicado,
    gettingPropietarioDuplicado: personaReferencia.gettingPropietarioDuplicado,
    gettingPropietarioDuplicadoError:
      personaReferencia.gettingPropietarioDuplicadoError
  };
};
